import { useState } from 'react';
import axios from 'axios';

const useSaveProjectTableEdits = () => {
  const [error, setError] = useState(null);

  const SaveProjectTableEdits = async (projectId, payloads) => {
    if (!projectId || !Array.isArray(payloads) || payloads.length === 0) {
      console.error('Invalid input to SaveProjectTableEdits:', { projectId, payloads });
      return { success: false, message: 'Invalid data format' };
    }

    try {
      const response = await axios.patch(
        `/api/Project/${projectId}`,
        payloads, // Send only the relevant payloads for this projectId
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        return { success: true, message: 'Project table data saved successfully.' };
      } else {
        console.error(`Failed request for project ${projectId}:`, response);
        return { success: false, message: 'Error saving data.' };
      }
    } catch (error) {
      console.error(`Error saving data for project ${projectId}:`, error);
      setError(error.message || 'Error saving data.');
      return { success: false, message: error.message };
    }
  };

  return { SaveProjectTableEdits, error };
};

export default useSaveProjectTableEdits;
